import React, { useState } from "react";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import { Collapse } from "antd";
import {
  TransactionItemStyled,
  TransactionMoreDeatils,
  TransactionMoreDeatilsItem,
  Container,
} from "./checkoutItem.styles";
const CheckoutItem = ({
  status,
  amount,
  persian_inserted_on,
  status_persian,
  type_persian,
  track,
  detail
}) => {
  const { Panel } = Collapse;
  const [mdVisible, setMdVisible] = useState(false);
  return (
    <Container>
      <TransactionItemStyled status={status}>
        <div className="tr_colored">
          <div>تسویه حساب</div>
          <div>{toSeperatedNum(toPersianNum(amount))} تومان</div>
        </div>
        <div className="mx-3 px-3 align-items-center">
          <div className="text-muted font-size--n2">نوع درخواست</div>
          <div className="font-weight-bold" style={{ color: "#353a50" }}>
            {type_persian}
          </div>
        </div>
        <div>
          <div className="tr_date font-size--n2 d-flex align-items-center justify-content-between">
            <div>
              {toPersianNum(
                persian_inserted_on.substring(
                  10,
                  persian_inserted_on.length - 3
                )
              )}
            </div>
            <div>{toPersianNum(persian_inserted_on.substring(0, 9))}</div>
          </div>
          <div>
            <div className="tr_status font-size--n2 text-center">
              {status_persian}
            </div>
            <button
              className="font-size--n3"
              onClick={() => setMdVisible(!mdVisible)}
            >
              مشاهده جزئیات
            </button>
          </div>
        </div>
      </TransactionItemStyled>
      <div className={mdVisible ? "" : "d-none"}>
        <TransactionMoreDeatils>
          <TransactionMoreDeatilsItem>
          <div>جزئیات</div>
            <div>{detail}</div>
          </TransactionMoreDeatilsItem>
          <TransactionMoreDeatilsItem>
            <div>کد پیگیری</div>
            <div>{track}</div>
          </TransactionMoreDeatilsItem>
        </TransactionMoreDeatils>
      </div>
    </Container>
  );
};

export default CheckoutItem;
